import * as R from 'ramda'
import { isActionOneOfTypes, isActionType } from 'helpers/ramda-ext/actions'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import { InitialState, State } from './member.types'

export const initialState: InitialState = {
  env: null,
  loggedIn: false,
  loggingIn: false,
  memberInfo: null,
  rankingStatementPdfFileUrl: null,
  version: null
}

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionType(Actions.member.AUTHENTICATING),
    () => R.assoc('loggingIn', true, state)
  ], [
    isActionType(Actions.member.MEMBER_INFO_FETCHED),
    (memberInfoFetchedAction) => R.merge(state, {
      env: R.toLower(R.path(['payload', 'response', 'env'], memberInfoFetchedAction)),
      loggedIn: true,
      loggingIn: false,
      memberInfo: R.merge(state.memberInfo, memberInfoFetchedAction.payload.response.member),
      rankingStatementPdfFileUrl: R.path(['payload', 'response', 'rankingStatementPdfFileUrl'], memberInfoFetchedAction),
      redirectionURL: R.path(['payload', 'response', 'location'], memberInfoFetchedAction),
      version: R.path(['payload', 'response', 'version'], memberInfoFetchedAction)
    })
  ], [
    isActionOneOfTypes([
      Actions.member.AUTHENTICATION_ERROR,
      Actions.application.SALE_CHANGES
    ]),
    R.always(initialState)
  ], [
    isActionType(Actions.version.NEW_VERSION),
    a => R.assoc('version', a.payload.version, state)
  ], [
    R.T,
    R.always(state)
  ]
])(action)
